import { Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import AboutPage from "./pages/AboutPage";
import ProjectDetailsPage from "./pages/ProjectDetailsPage"
import ErrorPage from "./pages/ErrorPage";
import ScrollToTop from "./components/utils/ScrollToTop";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Layout>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} exact />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:projectId" element={<ProjectDetailsPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Layout>
    </MotionConfig>
  );
}

export default App;
